// extracted by mini-css-extract-plugin
export default {"list-layout-full-height-background":"_2Rk0F","listLayoutFullHeightBackground":"_2Rk0F"};